// extracted by mini-css-extract-plugin
export var arrow = "styles-mod--arrow--ec6c8";
export var desktopView = "styles-mod--desktop-view--519e0";
export var founderImages = "styles-mod--founder-images--b8449";
export var founderMobile = "styles-mod--founder-mobile--6b9b5";
export var logos = "styles-mod--logos--73970";
export var mobileView = "styles-mod--mobile-view--2fe5d";
export var modalClose = "styles-mod--modal-close--5d74c";
export var modalCloseContainer = "styles-mod--modal-close-container--35291";
export var name = "styles-mod--name--d571e";
export var olavLogo = "styles-mod--olav-logo--a36d9";
export var olavsonLogo = "styles-mod--olavson-logo--52c18";
export var rbFounderTitle = "styles-mod--rb-founder-title--e9b7c";
export var rbTeamTitle = "styles-mod--rb-team-title--5803c";
export var rebrandingModal = "styles-mod--rebranding-modal--4e996";
export var rebrandingNoticeContainer = "styles-mod--rebranding-notice-container--fab70";
export var staffImages = "styles-mod--staff-images--23135";
export var staffMobile = "styles-mod--staff-mobile--4c6d3";
export var teamData = "styles-mod--team-data--c32c5";
export var teamInfo = "styles-mod--team-info--fe773";
export var text = "styles-mod--text--1ce1b";